import { Text } from '@chakra-ui/react';
import { subMonths } from 'date-fns';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import OBDocumentView from 'features/Bento/components/OBDocumentView';
import DocumentChecklist from 'features/Onboarding/components/DocumentChecklist';
import { formatDate } from 'helpers/date';

import locales from './locales';

interface CompanyPapersCheckProps {
  documentUrl: string;
  onValidate: () => void;
}

const CompanyPapersCheck = asBentoPage<CompanyPapersCheckProps>(
  ({ documentUrl, onPrev, onValidate }) => {
    return (
      <OBDocumentView
        data-testid="company-papers-check"
        onClose={onPrev}
        src={documentUrl}
      >
        <Text marginBottom="space-32">{locales.checkMessage}</Text>

        <DocumentChecklist
          checks={[
            {
              key: 'issue-date',
              label: locales.formatString(locales.checkIssueDate, {
                earliestIssueDate: formatDate(subMonths(new Date(), 3), 'PPP'),
              }),
            },
          ]}
          isLoading={false}
          onSubmit={onValidate}
        />
      </OBDocumentView>
    );
  },
);

export default CompanyPapersCheck;
